var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          !_vm.isApprDisabled && _vm.isUser
                            ? _c("c-appr-btn", {
                                ref: "appr-btn",
                                attrs: {
                                  name: "danger-journal-appr-btn",
                                  editable: _vm.editable,
                                  approvalInfo: _vm.approvalInfo,
                                },
                                on: {
                                  beforeApprAction: _vm.saveDataAppr,
                                  callbackApprAction: _vm.approvalCallback,
                                  requestAfterAction: _vm.getDetail,
                                },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.disabled &&
                                  _vm.editable &&
                                  !_vm.isUser &&
                                  _vm.isOld &&
                                  !_vm.isApprDisabled,
                                expression:
                                  "\n                  !disabled && editable && !isUser && isOld && !isApprDisabled\n                ",
                              },
                            ],
                            attrs: {
                              url: _vm.requestUrl,
                              isSubmit: _vm.isRequest,
                              param: _vm.nearAccident,
                              mappingType: "PUT",
                              label: "승인요청",
                              icon: "check",
                            },
                            on: {
                              beforeAction: _vm.requestNearAccident,
                              btnCallback: _vm.requestCallback,
                            },
                          }),
                          Boolean(_vm.nearAccident.iimNearAccidentId) &&
                          !_vm.isApprDisabled &&
                          !_vm.disabled &&
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  label: "삭제",
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.remove },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.disabled && _vm.editable,
                                expression: "!disabled && editable",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.nearAccident,
                              mappingType: _vm.saveType,
                              label: "저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveNearAccident,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.disabled &&
                                  _vm.editable &&
                                  _vm.approvalFlag,
                                expression:
                                  "disabled && editable && approvalFlag",
                              },
                            ],
                            attrs: {
                              url: _vm.requestUrl2,
                              isSubmit: _vm.isRequest2,
                              param: _vm.nearAccident,
                              mappingType: "PUT",
                              label: "승인요청 회수",
                              icon: "check",
                            },
                            on: {
                              beforeAction: _vm.requestNearAccident2,
                              btnCallback: _vm.requestCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "iimNearAccidentName",
                            label: "아차사고명",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearAccidentName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearAccidentName",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearAccidentName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            name: "iimNearAccidentNo",
                            label: "아차사고번호",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearAccidentNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearAccidentNo",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearAccidentNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            required: "",
                            codeGroupCd: "IIM_NEAR_KIND_CD",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            name: "iimNearKindCds",
                            label: "아차사고종류",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearKindCds,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "iimNearKindCds", $$v)
                            },
                            expression: "nearAccident.iimNearKindCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "datetime",
                            minuteStep: 10,
                            label: "발생일시",
                            name: "occurrenceDt",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceDt,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "occurrenceDt", $$v)
                            },
                            expression: "nearAccident.occurrenceDt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-process", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "공정",
                            name: "processCd",
                          },
                          model: {
                            value: _vm.nearAccident.processCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "processCd", $$v)
                            },
                            expression: "nearAccident.processCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "occurenceLocation",
                            label: "발생가능장소",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceLocation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "occurrenceLocation",
                                $$v
                              )
                            },
                            expression: "nearAccident.occurrenceLocation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "edit",
                            codeGroupCd: "IIM_GRADE_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "iimGradeCd",
                            label: "아차사고등급",
                          },
                          model: {
                            value: _vm.nearAccident.iimGradeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "iimGradeCd", $$v)
                            },
                            expression: "nearAccident.iimGradeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        !_vm.isVendor
                          ? _c("c-field", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                data: _vm.nearAccident,
                                deptValue: "discovererDeptCd",
                                label: "발견자",
                                type: "dept_user",
                                name: "discovererId",
                              },
                              model: {
                                value: _vm.nearAccident.discovererId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nearAccident,
                                    "discovererId",
                                    $$v
                                  )
                                },
                                expression: "nearAccident.discovererId",
                              },
                            })
                          : _c("c-vendor", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: true,
                                label: "발견업체",
                                name: "discovererId",
                              },
                              model: {
                                value: _vm.nearAccident.discovererId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nearAccident,
                                    "discovererId",
                                    $$v
                                  )
                                },
                                expression: "nearAccident.discovererId",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        !_vm.isVendor
                          ? _c("c-field", {
                              attrs: {
                                required: "",
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                data: _vm.nearAccident,
                                deptValue: "reportDeptCd",
                                type: "dept_user",
                                label: "보고자",
                                name: "reportUserId",
                              },
                              model: {
                                value: _vm.nearAccident.reportUserId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nearAccident,
                                    "reportUserId",
                                    $$v
                                  )
                                },
                                expression: "nearAccident.reportUserId",
                              },
                            })
                          : _c("c-vendor", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: true,
                                label: "보고업체",
                                name: "reportUserId",
                              },
                              model: {
                                value: _vm.nearAccident.reportUserId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nearAccident,
                                    "reportUserId",
                                    $$v
                                  )
                                },
                                expression: "nearAccident.reportUserId",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "datetime",
                            label: "보고일시",
                            minuteStep: 10,
                            name: "reportDt",
                          },
                          model: {
                            value: _vm.nearAccident.reportDt,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "reportDt", $$v)
                            },
                            expression: "nearAccident.reportDt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-dept", {
                          attrs: {
                            required: _vm.isUser,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            type: "edit",
                            label: "개선부서",
                            name: "reviewDeptCd",
                          },
                          model: {
                            value: _vm.nearAccident.reviewDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "reviewDeptCd", $$v)
                            },
                            expression: "nearAccident.reviewDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.isVendor
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                          },
                          [
                            _c("c-field", {
                              attrs: {
                                required: "",
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                data: _vm.nearAccident,
                                deptValue: "requestManagerDeptCd",
                                type: "dept_user",
                                userType: "user",
                                label: "업체승인담당자",
                                name: "requestManagerId",
                              },
                              model: {
                                value: _vm.nearAccident.requestManagerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nearAccident,
                                    "requestManagerId",
                                    $$v
                                  )
                                },
                                expression: "nearAccident.requestManagerId",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.nearAccident.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "plantCd", $$v)
                            },
                            expression: "nearAccident.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-radio", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "WEATHER_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "weatherCd",
                            label: "날씨",
                          },
                          model: {
                            value: _vm.nearAccident.weatherCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "weatherCd", $$v)
                            },
                            expression: "nearAccident.weatherCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                { staticClass: "cardClassDetailForm", attrs: { title: "" } },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 2,
                            label: "긴급조치사항",
                            name: "emergencyMeasures",
                          },
                          model: {
                            value: _vm.nearAccident.emergencyMeasures,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "emergencyMeasures",
                                $$v
                              )
                            },
                            expression: "nearAccident.emergencyMeasures",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            isCheck: true,
                            rows: 2,
                            label: "아차사고사항개요",
                            name: "overviewAccidentSituation",
                          },
                          on: { checkboxClick: _vm.checkboxClick },
                          model: {
                            value: _vm.nearAccident.overviewAccidentSituation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "overviewAccidentSituation",
                                $$v
                              )
                            },
                            expression:
                              "nearAccident.overviewAccidentSituation",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "사고발생시 상태" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_NEARMISS_DISCERN",
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            label: "인지기능",
                            name: "iimNearDiscernCds",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearDiscernCds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearDiscernCds",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearDiscernCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_NEARMISS_FUNCTION",
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            label: "사고기능",
                            name: "iimNearFunctionCds",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearFunctionCds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearFunctionCds",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearFunctionCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_NEARMISS_FEEL",
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            label: "감정",
                            name: "iimNearFeelCds",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearFeelCds,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "iimNearFeelCds", $$v)
                            },
                            expression: "nearAccident.iimNearFeelCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_NEARMISS_EQUIP",
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            label: "설비요인",
                            name: "iimNearEquipCds",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearEquipCds,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "iimNearEquipCds", $$v)
                            },
                            expression: "nearAccident.iimNearEquipCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_NEARMISS_MANAGE",
                            itemText: "codeName",
                            itemValue: "code",
                            isArray: false,
                            label: "관리요인",
                            name: "iimNearManageCds",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearManageCds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearManageCds",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearManageCds",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
            [
              _c(
                "c-card",
                { attrs: { title: "발생 가능형태" } },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            comboItems: _vm.occFirstItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "occurrenceModeLargeCd",
                            label: "대분류",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceModeLargeCd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "occurrenceModeLargeCd",
                                $$v
                              )
                            },
                            expression: "nearAccident.occurrenceModeLargeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            comboItems: _vm.occSecItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "occurrenceModeSmallCd",
                            label: "중분류",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceModeSmallCd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "occurrenceModeSmallCd",
                                $$v
                              )
                            },
                            expression: "nearAccident.occurrenceModeSmallCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "위험성평가" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "number",
                            name: "frequencyRisk",
                            label: "빈도",
                          },
                          on: { dataChange: _vm.dataChange },
                          model: {
                            value: _vm.nearAccident.frequencyRisk,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "frequencyRisk", $$v)
                            },
                            expression: "nearAccident.frequencyRisk",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "number",
                            name: "strengthRisk",
                            label: "강도",
                          },
                          on: { dataChange: _vm.dataChange },
                          model: {
                            value: _vm.nearAccident.strengthRisk,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "strengthRisk", $$v)
                            },
                            expression: "nearAccident.strengthRisk",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            type: "number",
                            name: "totalRisk",
                            label: "위험도",
                          },
                          model: {
                            value: _vm.nearAccident.totalRisk,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "totalRisk", $$v)
                            },
                            expression: "nearAccident.totalRisk",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "사고발생 가능 원인" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "directCause",
                            label: "직접원인",
                          },
                          model: {
                            value: _vm.nearAccident.directCause,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "directCause", $$v)
                            },
                            expression: "nearAccident.directCause",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "indirectCause",
                            label: "간접원인",
                          },
                          model: {
                            value: _vm.nearAccident.indirectCause,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "indirectCause", $$v)
                            },
                            expression: "nearAccident.indirectCause",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "openning",
                            label: "기인물",
                          },
                          model: {
                            value: _vm.nearAccident.openning,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "openning", $$v)
                            },
                            expression: "nearAccident.openning",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "injurious",
                            label: "가해물",
                          },
                          model: {
                            value: _vm.nearAccident.injurious,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "injurious", $$v)
                            },
                            expression: "nearAccident.injurious",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }